import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePreviewDialogStore } from "@/components/Search/PreviewDialogProvider";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { PRODUCTS_DETAIL_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import HandoutCard from "../components/HandoutCard";
import HomeCarouselButton from "../components/HomeCarouselButton";
import { HomeSectionTitle } from "../components/HomeSectionLayout";
import ViewAllCard from "../components/ViewAllCard";
import { useCarousel } from "../hooks/useCarousel";
const ProductSection = (param)=>{
    let { title , titleImageUrl , header , ctaButtonLink , ctaButtonName , products , entityId , trackingEventName , homeId , className  } = param;
    const router = useRouter();
    const { emblaRef , canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = useCarousel();
    const { openPreviewDialog  } = usePreviewDialogStore();
    const handleCardClick = (id)=>{
        router.push("".concat(PRODUCTS_DETAIL_PAGE).concat(id));
    };
    const handleSampleClick = (id)=>{
        openPreviewDialog({
            id
        });
    };
    // MX-385,386: CTA 버튼 클릭 트래킹
    const handleCtaClick = ()=>{
        if (!trackingEventName) return;
        mixpanelEvent(trackingEventName, {
            "Entity Id": entityId,
            "Home Id": homeId,
            "Section Title": title,
            Type: "전체보기 버튼",
            "Button Name": ctaButtonName,
            "Button URL": ctaButtonLink
        });
    };
    // MX-385,386: 모듈 내 전체보기 카드 클릭 트래킹
    const handleViewAllClick = ()=>{
        if (!trackingEventName) return;
        mixpanelEvent(trackingEventName, {
            "Entity Id": entityId,
            "Home Id": homeId,
            "Section Title": title,
            Type: "전체보기 버튼(모듈 내)",
            "Button Name": "전체보기",
            "Button URL": ctaButtonLink
        });
    };
    return /*#__PURE__*/ _jsxs("section", {
        className: "my-10 flex w-full flex-col gap-5 max-sm:my-6 max-sm:gap-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-end justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsx(HomeSectionTitle, {
                        title: title,
                        header: header,
                        isUseButton: Boolean(ctaButtonLink),
                        buttonText: ctaButtonName,
                        buttonUrl: ctaButtonLink,
                        titleImageUrl: titleImageUrl,
                        onCtaClick: handleCtaClick
                    }),
                    (products === null || products === void 0 ? void 0 : products.length) >= 5 && /*#__PURE__*/ _jsx(HomeCarouselButton, {
                        canScrollPrev: canScrollPrev,
                        canScrollNext: canScrollNext,
                        scrollPrev: scrollPrev,
                        scrollNext: scrollNext
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "relative",
                children: /*#__PURE__*/ _jsx("div", {
                    ref: emblaRef,
                    className: "overflow-hidden max-lg:px-8 max-sm:px-5",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-5 max-sm:gap-3",
                        children: [
                            products === null || products === void 0 ? void 0 : products.map((product)=>/*#__PURE__*/ _jsx(HandoutCard, {
                                    ...product,
                                    onSampleClick: ()=>handleSampleClick(product.id),
                                    onCardClick: ()=>handleCardClick(product.id)
                                }, product.id)),
                            (products === null || products === void 0 ? void 0 : products.length) >= 5 && Boolean(ctaButtonLink) && /*#__PURE__*/ _jsx(ViewAllCard, {
                                href: ctaButtonLink,
                                onClick: handleViewAllClick
                            })
                        ]
                    })
                })
            })
        ]
    });
};
export default ProductSection;
